import React, { useState,useEffect } from 'react'
import { getDocs,collection,doc,getDoc } from "firebase/firestore";
import { db } from '../../firebase';

function CompanySelected(prop) {
    // console.log(prop.cid);
  //   const [joblist, setJoblist] = useState([]);

  // const ref = collection(db, "Industry");
  // useEffect(() => {
  //   const getjob = async () => {
  //     const data = await getDocs(ref);
  //     setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  //   };
  //   getjob();
  // },[]);
  const [user,setUser]= useState("");
  useEffect(() => {
  getDoc(doc(db, `Industry/${prop.cid}`)).then((docSnap) => {
     if (docSnap.exists) {
       setUser(docSnap.data());
     }
   });
  },[]);
  return (
      
      <>
        <td>{user.cname}</td>
      </>
  
   
 
   
  )
}

export default CompanySelected
